import { cn } from '@utils';
import './style.scss';

type CommonButtonProps = {
  type?: 'primary' | 'secondary' | 'tertiary' | 'tertiary_new';
  className?: string;
  onClick?: () => void;
  icon?: React.ReactNode;
  size?: 'small' | 'regular';
  children?: React.ReactNode;
  disabled?: boolean;
  'data-testid'?: string;
};

export const CommonButton = ({
  type = 'primary',
  className = '',
  onClick = () => {},
  icon = null,
  size = 'regular',
  children,
  disabled,
  'data-testid': dataTestId,
}: CommonButtonProps) => (
  <button
    data-testid={dataTestId || 'common-button'}
    onClick={onClick}
    disabled={disabled}
    className={cn('common-button', { disabled }, [type, className, size])}
    type="button"
  >
    {icon
      && (
        <span
          className="d-flex"
          data-testid="common-button__icon"
        >
          {icon}
        </span>
      )}
    <span className="common-button__title">
      {children}
    </span>
  </button>
);
